import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const BarChart = ({
  chartData: initialChartData,
  chartOptions: initialChartOptions,
}) => {
  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    setChartData(initialChartData);
    setChartOptions(initialChartOptions);
  }, [initialChartData, initialChartOptions]);

  return (
    chartData.length > 0 && (
      <Chart
        options={chartOptions}
        series={chartData}
        type="bar"
        width="100%"
        height="100%"
      />
    )
  );
};

export default BarChart;
